module.exports = __webpack_public_path__ + "static/media/case-2.e69ead61.jpg";